(function () {
    'use strict';

    angular.module('blocks.auth', ['blocks.exception', 'blocks.logger', 'blocks.notifications']);
})();
